// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1IhFV","mylinks":"Navbar_mylinks__etrZr","navlogo":"Navbar_navlogo__-qQFN","navlinks":"Navbar_navlinks__2AKKs"};